var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{class:{
        'no-label': !_vm.label,
        [_vm.customClass]: true,
        'disabled-transparent': _vm.disabled && _vm.disableStyle === 'transparent',
        'disabled-greyed': _vm.disabled && _vm.disableStyle === 'greyed',
        'chart-refresh-btn': _vm.icon === 'el-icon-refresh'
    },attrs:{"size":_vm.size,"type":_vm.type,"loading":_vm.loading,"icon":_vm.icon,"disabled":_vm.effectiveDisabled,"plain":_vm.plain,"title":_vm.icon === 'el-icon-refresh' ? 'Làm mới' : ''},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }